import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Control, Controller } from "react-hook-form";
import { useDateLocale } from "../../hooks/useDateLocale";

interface Props {
  name: string;
  control: Control<any>;
  label: string;
  error?: any;
  disabled?: boolean;
  minDate?: Dayjs;
  maxDate?: Dayjs;
}

export function FormInputDate({
  name,
  control,
  label,
  error,
  disabled,
  minDate,
  maxDate,
}: Props) {
  const { dateFormat: format, adapterLocale } = useDateLocale();

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DatePicker
              label={label}
              format={format}
              value={field.value ? dayjs(field.value) : null}
              onChange={(date: Dayjs | null) =>
                field.onChange(
                  date?.isValid() ? date.format("YYYY-MM-DD") : "",
                )
              }
              disabled={disabled}
              minDate={minDate}
              maxDate={maxDate}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  error: !!error,
                  sx: {
                    marginBottom: error ? 0 : "1rem",
                    fontWeight: "bold",
                  },
                },
              }}
            />
          )}
        />
      </LocalizationProvider>
      {!!error && (
        <Box
          sx={{
            marginBottom: "1rem",
            marginTop: "4px",
            fontSize: "14px",
            color: "var(--red-100)",
          }}
        >
          {error.message}
        </Box>
      )}
    </>
  );
}
